import Serializer from 'umg-ember-backend/serializers/application';

export default class PersonSerializer extends Serializer {
  attrs = {
    gender: 'genderId',
  };
}
